import { allCountries, CountryCode } from '../models/countries'

export const isCountryCode = (c: string): c is CountryCode => c in allCountries
